import * as React from 'react';
import { useLanguageLocale } from '../../hooks/language-locale-hooks';
import { Typography } from '@mui/material';
import style from "./style.module.css";
interface Props {
    lastRefresh?: Date;
}

const LastRetrievedTimestamp: React.FC<Props> = ({ lastRefresh }) => {

    const { t } = useLanguageLocale();

    const [elapsedTime, setElapsedTime] = React.useState<string>(`0 ${t('COMMON.HOURS')}, 0 ${t('COMMON.MINUTES')} ${t('COMMON.AGO')}`);
    const lastRetrievedLabel = t('COMMON.LAST_RETRIEVED');
    const timestampPrefix = lastRetrievedLabel.trim().endsWith(':') ? lastRetrievedLabel : `${lastRetrievedLabel}:`;

    React.useEffect(() => {
        if (!lastRefresh) return;

        const timer = setInterval(() => {
            const now = new Date();
            const diff = Math.floor((now.getTime() - lastRefresh.getTime()) / 1000);
            const hours = Math.floor(diff / 3600);
            const minutes = Math.floor((diff % 3600) / 60);
            const seconds = diff % 60;
            setElapsedTime(`${hours} ${t('COMMON.HOURS')}, ${minutes} ${t('COMMON.MINUTES')} ${t('COMMON.AGO')}`);
        }, 1000);

        return () => clearInterval(timer);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [lastRefresh]);

    return (
        <Typography
            variant="caption"
            data-testid="last-retrieved-time"
            className={style.lastRetrieveTimestamp}>
            {`${timestampPrefix} ${elapsedTime}`}
        </Typography>
    );
};

export default LastRetrievedTimestamp;
